import type { RouteLocationAsRelativeGeneric } from 'vue-router'

// TODO: Удалить
export const withRouteParams = (to: RouteLocationAsRelativeGeneric) => to
